import "../../jquery-ui";

const handleAutocomplete = (source) => {
  return (request, response) => {
    let term = request.term.toLowerCase();
    let exactMatching = [];
    let cities = [];
    let countries = [];

    source.forEach(function (elem) {
      // Exact Matching: Port Value in EN and AR
      elem.value_ar?.replace(/[أإ]/g, 'ا').toLowerCase().trim() == term?.replace(/[أإ]/g, 'ا')
        ? exactMatching.push(elem)
        : elem.value.toLowerCase().trim() == term
          ? exactMatching.push(elem)
          // Cities Matching: Port INCLUDES Value in EN and AR
          : elem.value_ar?.replace(/[أإ]/g, 'ا').toLowerCase().includes(term?.replace(/[أإ]/g, 'ا'))
            ? cities.push(elem)
            : elem.value.toLowerCase().includes(term)
              ? cities.push(elem)
              // Country Matching: Country INCLUDES Country_Value in EN and AR
              : elem.country_ar?.replace(/[أإ]/g, 'ا').toLowerCase().includes(term?.replace(/[أإ]/g, 'ا'))
                ? countries.push(elem)
                : elem.country.toLowerCase().includes(term)
                  ? countries.push(elem)
                  // Check ISO Code
                  : elem.code != null && elem.code.toLowerCase().includes(term)
                    ? countries.push(elem)
                    // When initializing with data, they are in english so we need to search values not display names
                    : false
    });

    response(exactMatching.concat(cities).concat(countries).slice(0, 25));
  };
};


const autocompleteSelectorOption = item => {
  return `
    <li class='notranslate' translate='no' data-port="${item.port}">
      <div class="search-select-tag"> 
        ${item.port ? "Ports" : "Areas"}
      </div>
      <div class="search-select-item">
        <span class="search-select-item-img">
          <img src="${item.imgUrl}" alt="${item.display_country}"/>
        </span>
        <span class="search-select-item-icon">
          <img src="${item.icon}" alt="${item.port ? 'port' : 'area'}"/>
        </span>
        <span class="search-select-item-label">
          <span class="truncate">${item.display_name}</span>
          <span class="truncate">${item.display_country}</span>
        </span>
      </div>
    </li>
  `;
};

const createFlexibleInputComponent = (selector, source) => {
  const { inputSelector, flagSelector, markerSelector } = selector;

  let searchAutocomplete = $(inputSelector).autocomplete({
    classes: { [`ui-autocomplete`]: `autocomplete-country-select-list` },
    minLength: 0,
    delay: 200,
    source: handleAutocomplete(source),
    select: function (event, ui) {
      $(inputSelector).val(ui.item.display_name);
      $(flagSelector).css('display', 'flex');
      $(`${flagSelector} .flag`).attr('src', ui.item.imgUrl);
      $(`${flagSelector} .icon`).attr('src', ui.item.iconUrl);
      $(markerSelector).css('display', 'none');
      return false;
    },
    open: function () {
      let { x: left } = $(this).closest('.break_bulk__location_input').get(0).getBoundingClientRect();
      $('.autocomplete-country-select-list:visible').css({ top: '+=18', left });
    },
    minLength: 2,
    delay: 500
  });

  searchAutocomplete.on('focus', function () {
    $(this).autocomplete("search");
  })

  searchAutocomplete.autocomplete('instance')._renderItem = function (ul, item) {
    return $(autocompleteSelectorOption(item)).appendTo(ul);
  };
}


export function createAutoCompleteInput() {
  let selectors = [
    {
      inputSelector: '#break_bulk_request_pol',
      flagSelector: '#pol_flag',
      markerSelector: '#pol_marker'
    },
    {
      inputSelector: '#break_bulk_request_pod',
      flagSelector: '#pod_flag',
      markerSelector: '#pod_marker'
    }
  ]

  $(() => {
    $.ajax({
      accepts: {
        mycustomtype: 'application/json'
      },
      dataType: 'json',
      url: '/en/selectors/',
      success: function (data) {
        selectors.forEach((selector) => createFlexibleInputComponent(selector, data.locations))
      }
    })
  });
}